

export function button1_click(event) {
	$w('#text32').show();
	//Add your code for this event here: 
}



export function button2_click(event) {
	$w('#text33').show();
	//Add your code for this event here: 
}

export function button3_click(event) {
	$w('#text34').show();
	//Add your code for this event here: 
}